import { Controller } from "@hotwired/stimulus"

// Reads native checked state only. Consumers still own change events and saving.
export default class extends Controller {
  static targets = ["option"]

  connect() {
    this.active = true
    this.refresh = () => this.position(false)
    this.reset = () => {
      cancelAnimationFrame(this.resetFrame)
      // Native reset restores checked state after the reset event dispatches.
      this.resetFrame = requestAnimationFrame(this.refresh)
    }
    this.beforeCache = () => this.clearPresentation()
    this.form = this.element.closest("form")
    this.form?.addEventListener("reset", this.reset)
    this.observer = new ResizeObserver(this.refresh)
    this.observer.observe(this.element)
    this.optionTargets.forEach(option => this.observer.observe(option))
    document.fonts?.addEventListener("loadingdone", this.refresh)
    document.addEventListener("turbo:before-cache", this.beforeCache)
    this.position(false)
  }

  disconnect() {
    this.active = false
    cancelAnimationFrame(this.resetFrame)
    this.observer?.disconnect()
    this.form?.removeEventListener("reset", this.reset)
    document.fonts?.removeEventListener("loadingdone", this.refresh)
    document.removeEventListener("turbo:before-cache", this.beforeCache)
    this.clearPresentation()
  }

  clearPresentation() {
    delete this.element.dataset.motionReady
    delete this.element.dataset.hasSelection
    delete this.element.dataset.animate
  }

  select() { this.position(true) }

  position(animate = false) {
    if (!this.active) return
    const selected = this.optionTargets.find(option => option.querySelector("input[type=radio]:checked"))
    if (!selected || !this.element.offsetWidth || !selected.offsetWidth) {
      this.clearPresentation()
      return
    }
    const hadSelection = this.element.hasAttribute("data-has-selection")
    this.element.toggleAttribute("data-animate", animate && hadSelection)
    // Layout coordinates remain correct inside transformed drawers/containers.
    // Both axes are always measured; CSS picks whichever pair matches the
    // track's current flex-direction (row vs a small-screen column stack),
    // so this controller stays layout-direction-agnostic.
    this.element.style.setProperty("--segment-left", `${selected.offsetLeft}px`)
    this.element.style.setProperty("--segment-width", `${selected.offsetWidth}px`)
    this.element.style.setProperty("--segment-top", `${selected.offsetTop}px`)
    this.element.style.setProperty("--segment-height", `${selected.offsetHeight}px`)
    this.element.dataset.hasSelection = ""
    this.element.dataset.motionReady = ""
  }
}
